import { ERROR_CODES } from '../types/errors';
import i18n from '../../config/i18n';

/**
 * Mapeo de códigos de error a claves de traducción.
 */
const ERROR_CODE_TO_I18N_KEY: Record<string, string> = {
  // Auth
  [ERROR_CODES.AUTH_INVALID_CREDENTIALS]: 'errors.authInvalidCredentials',
  [ERROR_CODES.AUTH_INVALID_TOKEN]: 'errors.authInvalidToken',
  [ERROR_CODES.AUTH_TOKEN_EXPIRED]: 'errors.authTokenExpired',
  [ERROR_CODES.AUTH_MISSING_TOKEN]: 'errors.authMissingToken',
  [ERROR_CODES.AUTH_USER_NOT_FOUND]: 'errors.authUserNotFound',
  [ERROR_CODES.AUTH_USER_ALREADY_EXISTS]: 'errors.authUserAlreadyExists',
  [ERROR_CODES.AUTH_INACTIVE_USER]: 'errors.authInactiveUser',
  [ERROR_CODES.AUTH_INSUFFICIENT_PERMISSIONS]: 'errors.authInsufficientPermissions',
  [ERROR_CODES.AUTH_VALIDATION_ERROR]: 'errors.authValidationError',

  // Validation
  [ERROR_CODES.VALIDATION_ERROR]: 'errors.validationError',

  // Templates
  [ERROR_CODES.TEMPLATE_NOT_FOUND]: 'errors.templateNotFound',
  [ERROR_CODES.TEMPLATE_VALIDATION_ERROR]: 'errors.templateValidationError',
  [ERROR_CODES.TEMPLATE_RETRIEVAL_ERROR]: 'errors.templateRetrievalError',
  [ERROR_CODES.TEMPLATE_ALREADY_EXISTS]: 'errors.templateAlreadyExists',
  [ERROR_CODES.TEMPLATE_NAME_DUPLICATE]: 'errors.templateNameDuplicate',
  [ERROR_CODES.TEMPLATE_NO_TEMPLATES_FOUND]: 'errors.templateNoTemplatesFound',
  [ERROR_CODES.TEMPLATE_INVALID_FORMAT]: 'errors.templateInvalidFormat',
  [ERROR_CODES.TEMPLATE_ACCESS_DENIED]: 'errors.templateAccessDenied',
  [ERROR_CODES.BLOCK_LIMIT_REACHED]: 'errors.blockLimitReached',

  // Reports
  [ERROR_CODES.REPORT_NOT_FOUND]: 'errors.reportNotFound',
  [ERROR_CODES.REPORT_VALIDATION_ERROR]: 'errors.reportValidationError',
  [ERROR_CODES.REPORT_GENERATION_ERROR]: 'errors.reportGenerationError',
  [ERROR_CODES.REPORT_SAVE_ERROR]: 'errors.reportSaveError',
  [ERROR_CODES.REPORT_ALREADY_EXISTS]: 'errors.reportAlreadyExists',
  [ERROR_CODES.REPORT_RETRIEVAL_ERROR]: 'errors.reportRetrievalError',
  [ERROR_CODES.REPORT_MODALITY_NOT_FOUND]: 'errors.reportModalityNotFound',
  [ERROR_CODES.REPORT_ACCESS_DENIED]: 'errors.reportAccessDenied',
  [ERROR_CODES.REPORT_DATA_INVALID]: 'errors.reportDataInvalid',
  [ERROR_CODES.REPORT_MISSING_FIELD]: 'errors.reportMissingField',
  [ERROR_CODES.REPORT_INVALID_FORMAT]: 'errors.reportInvalidFormat',
  [ERROR_CODES.REPORT_INVALID_GENERATION_REQUEST]: 'errors.reportInvalidGenerationRequest',
  [ERROR_CODES.REPORT_API_ERROR]: 'errors.reportApiError',
  [ERROR_CODES.REPORT_SERVICE_ERROR]: 'errors.reportServiceError',
  [ERROR_CODES.REPORT_ALIGNMENT_ERROR]: 'errors.reportAlignmentError',
  [ERROR_CODES.REPORT_NO_MODALITY_OR_REGIONS]: 'errors.reportNoModalityOrRegions',
  [ERROR_CODES.REPORT_TEMPLATES_FOUND_FOR_DIFFERENT_TYPE]: 'errors.reportTemplatesFoundForDifferentType',

  // Reports - Python API (forwarded codes)
  [ERROR_CODES.REPORTS_TEMPLATE_NOT_FOUND]: 'errors.reportsTemplateNotFound',
  [ERROR_CODES.REPORTS_TEMPLATE_INCOMPLETE]: 'errors.reportsTemplateIncomplete',
  [ERROR_CODES.REPORTS_TEMPLATE_CONTENT_NOT_FOUND]: 'errors.reportsTemplateContentNotFound',
  [ERROR_CODES.REPORTS_TEMPLATE_CONTENT_INCOMPLETE]: 'errors.reportsTemplateContentIncomplete',
  [ERROR_CODES.REPORTS_PROMPT_NOT_FOUND]: 'errors.reportsPromptNotFound',
  [ERROR_CODES.REPORTS_FINDINGS_GENERATION_ERROR]: 'errors.reportsFindingsGenerationError',
  [ERROR_CODES.REPORTS_CONCLUSION_GENERATION_ERROR]: 'errors.reportsConclusionGenerationError',
  [ERROR_CODES.REPORTS_SECTION_GENERATION_ERROR]: 'errors.reportsSectionGenerationError',
  [ERROR_CODES.REPORTS_PARALLEL_GENERATION_ERROR]: 'errors.reportsParallelGenerationError',
  [ERROR_CODES.REPORTS_INVALID_GENERATION_PARAMETERS]: 'errors.reportsInvalidGenerationParameters',
  [ERROR_CODES.REPORTS_ALIGNMENT_ERROR]: 'errors.reportsAlignmentError',
  [ERROR_CODES.REPORTS_PRE_SAVE_REVIEW_ERROR]: 'errors.reportsPreSaveReviewError',
  [ERROR_CODES.REPORTS_LLM_SERVICE_ERROR]: 'errors.reportsLlmServiceError',
  [ERROR_CODES.REPORT_LANGUAGE_CODE_NOT_FOUND]: 'errors.reportLanguageCodeNotFound',
  [ERROR_CODES.REPORT_INACTIVE_TEMPLATE]: 'errors.reportInactiveTemplate',
  [ERROR_CODES.REPORT_ANATOMICAL_REGION_NOT_FOUND]: 'errors.reportAnatomicalRegionNotFound',
  [ERROR_CODES.REPORT_VARIANT_NOT_FOUND]: 'errors.reportVariantNotFound',
  [ERROR_CODES.REPORT_TEMPLATE_NOT_FOUND]: 'errors.reportTemplateNotFound',

  // Ainovis
  [ERROR_CODES.AINOVIS_API_ERROR]: 'errors.ainovisApiError',
  [ERROR_CODES.AINOVIS_CONNECTION_ERROR]: 'errors.ainovisConnectionError',
  [ERROR_CODES.AINOVIS_TIMEOUT_ERROR]: 'errors.ainovisTimeoutError',
  [ERROR_CODES.AINOVIS_INVALID_AUDIO_FORMAT]: 'errors.ainovisInvalidAudioFormat',
  [ERROR_CODES.AINOVIS_AUDIO_FILE_SIZE_EXCEEDED]: 'errors.ainovisAudioFileSizeExceeded',
  [ERROR_CODES.AINOVIS_MISSING_AUDIO_FILE]: 'errors.ainovisMissingAudioFile',

  // STT (Speech-to-Text)
  [ERROR_CODES.STT_SERVICE_ERROR]: 'errors.sttServiceError',
  [ERROR_CODES.STT_VALIDATION_ERROR]: 'errors.sttValidationError',
  [ERROR_CODES.STT_MISSING_FIELD]: 'errors.sttMissingField',
  [ERROR_CODES.STT_PROCESSING_ERROR]: 'errors.sttProcessingError',
  [ERROR_CODES.STT_API_ERROR]: 'errors.sttApiError',

  // STT - Python API (forwarded codes)
  [ERROR_CODES.STT_NO_VOICE_DETECTED]: 'errors.sttNoVoiceDetected',
  [ERROR_CODES.STT_AUDIO_PROCESSING_ERROR]: 'errors.sttAudioProcessingError',
  [ERROR_CODES.STT_NO_AUDIO_CHUNKS]: 'errors.sttNoAudioChunks',
  [ERROR_CODES.STT_TRANSCRIPTION_ERROR]: 'errors.sttTranscriptionError',
  [ERROR_CODES.STT_NO_TRANSCRIPTION_RESULTS]: 'errors.sttNoTranscriptionResults',
  [ERROR_CODES.STT_EMPTY_TRANSCRIPT]: 'errors.sttEmptyTranscript',
  [ERROR_CODES.STT_INVALID_AUDIO_FILE]: 'errors.sttInvalidAudioFile',
  [ERROR_CODES.STT_AUDIO_FORMAT_NOT_SUPPORTED]: 'errors.sttAudioFormatNotSupported',

  // Email
  [ERROR_CODES.EMAIL_SEND_FAILED]: 'errors.emailSendFailed',
  [ERROR_CODES.EMAIL_INVALID_CONFIG]: 'errors.emailInvalidConfig',
  [ERROR_CODES.EMAIL_INVALID_ADDRESS]: 'errors.emailInvalidAddress',
  [ERROR_CODES.EMAIL_TEMPLATE_NOT_FOUND]: 'errors.emailTemplateNotFound',
  [ERROR_CODES.EMAIL_TEMPLATE_RENDER_ERROR]: 'errors.emailTemplateRenderError',
  [ERROR_CODES.EMAIL_CONNECTION_ERROR]: 'errors.emailConnectionError',
  [ERROR_CODES.EMAIL_AUTHENTICATION_ERROR]: 'errors.emailAuthenticationError',

  // Network
  [ERROR_CODES.NETWORK_ERROR]: 'errors.networkError',
  [ERROR_CODES.NO_RESPONSE]: 'errors.noResponse',
  [ERROR_CODES.REQUEST_SETUP_ERROR]: 'errors.requestSetupError',
};

/**
 * Obtiene el mensaje de error traducido correspondiente a un código.
 * Soporta interpolación con los details del error para mensajes dinámicos.
 */
export function getErrorMessage(
  code: string, 
  backendMessage?: string,
  details?: Record<string, any>
): string {
  // Caso especial: REPORT_TEMPLATES_FOUND_FOR_DIFFERENT_TYPE usa interpolación con el tipo disponible
  if (code === ERROR_CODES.REPORT_TEMPLATES_FOUND_FOR_DIFFERENT_TYPE && details) {
    const { available_type } = details;
    const availableType = i18n.t(`errors.reportTemplateType_${available_type}`);
    return i18n.t('errors.reportTemplatesFoundForDifferentType', { availableType });
  }

  const i18nKey = ERROR_CODE_TO_I18N_KEY[code];
  
  if (i18nKey) {
    // Los details viajan como variables de interpolación (p.ej. {{limit}} en blockLimitReached).
    const translatedMessage = i18n.t(i18nKey, details);
    
    // Siempre preferir el mensaje traducido cuando existe una clave i18n,
    // ya que el mensaje del backend puede contener detalles técnicos no amigables
    return translatedMessage;
  }
  
  return backendMessage || i18n.t('errors.unexpectedError');
}

/**
 * Mapeo de códigos de error a mensajes amigables (DEPRECATED - usar getErrorMessage)
 * @deprecated Use getErrorMessage function instead for i18n support
 */
export const DEFAULT_ERROR_MESSAGES: Record<string, string> = {
  // Este objeto se mantiene por compatibilidad pero ya no se usa directamente
};
